import { Card as e, CardContent as t, CardFooter as n, CardHeader as r } from "../Card/Card.mjs";
import { keyframes as i, styled as a } from "styled-components";
//#region src/components/FloatingPanel/FloatingPanel.styled.ts
var o = i`
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
`, s = a.div`
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 9999;
    width: 430px;
    height: 750px;
    animation: ${o} 0.25s ease-out;

    @media (max-width: 639px) {
        position: static;
        width: 100%;
        height: 100%;
        bottom: unset;
        right: unset;
        border-radius: 0;
        animation: none;
    }
`, c = a(e)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: ${({ theme: e }) => e.colors.muted};

    @media (max-width: 639px) {
        border-radius: 0;
    }
`, l = a(r)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    margin-bottom: 0;
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
`, u = a.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.cardForeground};
`, d = a(t)`
    flex: 1;
    overflow-y: auto;
    padding: ${({ theme: e }) => e.spacing(2)};
    gap: ${({ theme: e }) => e.spacing(1.5)};

    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme: e }) => e.colors.border};
        border-radius: 4px;
    }
`, f = a.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: ${({ theme: e }) => e.spacing(3)};
    padding: ${({ theme: e }) => e.spacing(4)};
`, p = a.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme: e }) => e.spacing(1)};
    justify-content: center;
    width: 100%;
`, m = a.button`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    background: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.full};
    padding: ${({ theme: e }) => e.spacing(.75, 2)};
    cursor: pointer;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.cardForeground};
    text-align: left;
    transition:
        background 0.15s ease,
        border-color 0.15s ease;

    &:hover {
        background: ${({ theme: e }) => e.colors.muted};
        border-color: ${({ theme: e }) => e.colors.primary};
    }
`, h = a(n)`
    padding: ${({ theme: e }) => e.spacing(2, 3)};
    margin-top: 0;
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    form {
        width: 100%;
    }
`;
//#endregion
export { c as PanelCard, s as PanelContainer, d as PanelContent, f as PanelEmptyState, h as PanelFooter, l as PanelHeader, u as PanelHeaderInfo, m as PanelSuggestionChip, p as PanelSuggestionsRow };
